import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import useChangeLanguage from 'hooks/useChangeLanguage';
import useLocale from 'hooks/useLocale';

import { languages } from 'utils/localization';

import * as S from './TermsAndConditions.styled';

const LinkViewer = ({ children }) => {
	const { t } = useTranslation();
	return <a href={children}>{t(children)}</a>;
};

const TermsAndConditions = () => {
	const { lang } = useParams();
	const { LangCountryCode } = useLocale();
	const changeLanguage = useChangeLanguage();

	useEffect(() => {
		const language = languages.find((language) => language.systemCode === lang);
		if (language) {
			if (language !== LangCountryCode) changeLanguage(language.code);
		}
	}, [lang]);

	return (
		<S.Container>
			<Image
				width="10rem"
				height="10rem"
				url={'https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png'}
				alt="logo"
			/>
			<S.TextContainer>
				<Typography variant="h1" noWrap>
					termsAndConditions
				</Typography>
				<Typography noWrap>
					<Trans
						i18nKey={'privacyPolicyText'}
						components={{
							linkViewer: <LinkViewer />
						}}
					/>
				</Typography>
			</S.TextContainer>
		</S.Container>
	);
};

export default TermsAndConditions;
